"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

require("moment/locale/zh-cn");

var _axios = _interopRequireDefault(require("axios"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _errorPage = _interopRequireDefault(require("../../../error-views/errorPage"));

var _RmName = _interopRequireDefault(require("../../../../RmName.json"));

//import { useHistory } from "react-router-dom";
var rules = {
  code: [{
    required: true,
    message: "Please enter ".concat(_RmName.default.nameCode)
  }],
  name: [{
    required: true,
    message: 'Please enter name'
  }],
  doj: [{
    required: true,
    message: 'Please enter joining date'
  }],
  contact: [{
    required: true,
    message: 'Please enter contact number'
  }],
  address: [{
    required: true,
    message: 'Please enter address'
  }],
  password: [{
    required: true,
    message: 'Please enter password'
  }]
};

var ADDRM = function ADDRM(_ref) {
  var rmCodeJson = _ref.rmCodeJson,
      btnName = _ref.btnName,
      AddNew = _ref.AddNew;
  //const history = useHistory();
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1]; // const [RMData,setRMData]=useState([]);
  // const [newRMCode,setNewRMCode]=useState('');
  // console.log(rmCodeJson)
  // async function getData() {
  // 	let url = config.rmDetails + cl;
  // 	await axios.get(url, { headers: { 'Authorization': token } }).then(
  // 	  (response) => {
  // 		if (response.data.status == "error") setapiError(response.data);
  // 		else {
  // 		  let rmDetails = response.data;
  // 		  setRMData(rmDetails);
  // 		  if(RMData.length===0)
  // 			{
  // 				let str = cl + 'R0';
  // 				let data = {RM_code: str}
  // 				lastRM = data;
  // 			}
  // 			else
  // 			{
  // 				let data =RMData[RMData.length-1];
  // 				lastRM = data;
  // 			} 
  // 			let code = lastRM.RM_code.slice(2);
  // 			let changeCode = (+code)+1;
  // 			let newCode = cl+'R'+changeCode;
  // 			setNewRMCode(newCode)		
  // 		}
  // 	  },
  // 	  error => {
  // 		setapiError(error.response);
  // 	  }
  // 	)
  //   }


  (0, _react.useEffect)(function () {
    var code = rmCodeJson.RM_code;
    var newCode = cl + 'R' + code;
    var initialFormValues = {
      'RM_Code': newCode,
      'RM_Name': '',
      'Start_Date': '',
      'Phone_Number': '',
      'Address': '',
      'RM_password': ''
    };
    form.setFieldsValue(initialFormValues);
    setLoading(false); // eslint-disable-next-line 
  }, [rmCodeJson]);

  var onFinish = function onFinish(fieldsValue) {
    var f1 = form.getFieldValue();
    var obj = {
      'RM_Code': f1.RM_Code,
      'RM_Name': f1.RM_Name,
      'Start_Date': f1.Start_Date.format('YYYY-MM-DD'),
      'Phone_Number': f1.Phone_Number,
      'Address': f1.Address,
      'RM_password': f1.RM_password
    };
    var url = _config.default.AddNewRM + cl;

    _axios.default.post(url, obj, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);else {
        alert("Updated Successfully");
        form.resetFields();
        window.location.reload();
      }
    }, function (err) {
      var obj = {
        "status": "error",
        "message": "Network Error"
      };
      if (err.response) setapiError(err.response);else setapiError(obj);
    });
  };

  return loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement("div", null, apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Basic Info"
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    form: form,
    name: "Fill Details of New RM",
    onFinish: onFinish
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "RM_Code",
    label: _RmName.default.nameCode,
    rules: rules.code
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: _RmName.default.nameCode,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "RM_Name",
    label: _RmName.default.RMName,
    rules: rules.name
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: _RmName.default.RMName
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Start_Date",
    label: "Date of Joining",
    rules: rules.doj
  }, /*#__PURE__*/_react.default.createElement(_antd.DatePicker, null)), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Phone_Number",
    label: "Contact Number",
    rules: [{
      required: true,
      message: 'Please Enter Valid Number!'
    }, function () {
      return {
        validator: function validator(_, value) {
          var pattern = new RegExp(/^[0-9\b]+$/);

          if (pattern.test(value) && value.length === 10) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('Please Check the Phone Number!'));
        }
      };
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    rows: 4
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "Address",
    label: "Address",
    rules: rules.address
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    rows: 4
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "RM_password",
    label: "Password",
    rules: rules.password
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    rows: 4
  })), /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 15,
    sm: 15,
    md: 15,
    lg: 20,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "link",
    onClick: function onClick() {
      return AddNew();
    }
  }, btnName)), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 9,
    sm: 9,
    md: 9,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    htmlType: "submit"
  }, "Add"))))));
};

var _default = ADDRM;
exports.default = _default;